import { useEffect, useState } from 'react';
import { FroalaTextareaView } from '@/components/Froala/FroalaTextareaView';
import { CorrectionWidgetSection } from './CorrectionWidgetSection';
import { round2, deep_copy, parseNumber } from '@/util';

export const SimpleCorrectionContent = ({ correction, feedback }: any) => {
  const [widgets, setWidgets] = useState<any>(null);
  const [submitScore, setSubmitScore] = useState<any>({});

  useEffect(() => {
    const source = correction;
    if (!source) return;

    const newWidgets = deep_copy(source.widgets);
    const validWidgets = Object.values<any>(newWidgets).filter(
      (widget) => !widget.state.noSubmit
    );

    for (const widget of validWidgets) {
      widget.answer.answered = true;
      if (!widget?.correction) {
        widget.correction = {};
        widget.correction.score = 0;
      }
    }

    setWidgets(validWidgets);

    setSubmitScore(
      validWidgets.reduce((acc, widget) => {
        acc[widget.state.uid] = parseNumber(
          widget.correction?.score,
          widget.state?.score || 0
        );
        return acc;
      }, {})
    );
  }, [correction]);

  if (!widgets) return null;

  const sumMaxScore: any = widgets.reduce(
    (acc: any, widget: any) => acc + parseFloat(widget?.state?.score || 0),
    0
  );
  const sumScore: any = Object.values(submitScore).reduce(
    (acc: any, value: any) => acc + parseFloat(value || 0),
    0
  );

  return (
    <div className="mx-auto mb-8 flex w-full max-w-4xl flex-col px-3">
      {sumMaxScore ? (
        <div className="mt-7 flex items-center text-base text-secondary-04">
          Total Score:
          <span className="ml-3 mr-1 font-semibold">
            {round2(sumScore)}/{sumMaxScore}
          </span>
        </div>
      ) : null}

      {correction?.feedback && (
        <div className="print-keep my-5 rounded-md border border-solid bg-grey-transparent-01 p-3 text-sm text-grey-08">
          <h3 className="text-base text-grey-05">Comments</h3>
          <div className="my-3">
            <FroalaTextareaView value={correction?.feedback} />
          </div>
        </div>
      )}

      {widgets.map((widget: any, i: number) => (
        <CorrectionWidgetSection
          key={widget.state.uid}
          state={widget}
          i={i}
          coorectionPage={true}
          resaltPage={true}
          score={submitScore[widget.state.uid]}
          setScore={() => {}}
          userId={null}
          userLang={null}
          feedback={null}
          titleWidget={widget.state.titleWidget}
          setFeedback={() => {}}
          collapse={false}
          expand={true}
        />
      ))}
    </div>
  );
};
